import { ActionType } from "../../../../../../../../react-core/Flux/ActionType";
import { AccountDisinvestmentStrategyClient } from "../../../../../../../../Wrap/Api/Account/AccountDisinvestmentStrategy";
import { PensionArrangementClient } from "../../../../../../../../Wrap/Api/Account/PensionArrangement";
import { ProductOverviewClient } from "../../../../../../../../Wrap/Api/ProductOverview/Charges/ProductOverview";
import { AccountDisinvestmentStrategy } from "../../../../../../../../Wrap/Models/Domains/Account/AccountDisinvestmentStrategy";
import { ProductOverviewChargeDispatcher } from "../Stores/Variable";
import { PensionArrangement } from "../../../../../../../../Wrap/Models/Models/Account/PensionArrangement";
import { DrawdownPriceLockClient } from "../../../../../../../../Wrap/Api/Drawdown/DrawdownPriceLock";
import { DrawdownPriceLockModel } from "../../../../../../../../Wrap/Models/Models/QuoteAndApplyBase/Shared/DrawdownPriceLockModel";
import { ProductDetailsClient } from "../../../../../../../../Wrap/Api/Account/ProductDetails";
import { ProductDetailsDispatcher } from "../../../../Common/Account/ProductDetails/Store/Variable";

export class ProductOverviewChargeAction {
    public static getCharge(hierarchyId: string) {
        const client = new ProductOverviewClient();
        const promise = client.get(hierarchyId);
        promise.onSuccess((data) => {
            ProductOverviewChargeDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: data,
            });
        });
        promise.onError((err) => { });
    }

    public static getProductDetails(hierarchyId: string) {
        const client = new ProductDetailsClient();
        const promise = client.get(hierarchyId);
        promise.onSuccess((data) => {
            ProductDetailsDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: data,
            });
        });
        promise.onError((err) => { });
    }

    public static getPensionArrangement(
        hierarchyId: string,
        callBack?: (val: PensionArrangement[]) => void,
        includeClosed?: boolean,
    ) {
        const client = new PensionArrangementClient();
        const promise = client.get(hierarchyId, !!includeClosed);
        promise.onSuccess((data) => {
            if (callBack) {
                callBack(data);
            }
        });

        promise.onError((err) => { });
    }

    public static getAccountDisinvestmentStrategy(
        hierarchyId: string,
        callBack?: (val: AccountDisinvestmentStrategy) => void
    ) {
        const client = new AccountDisinvestmentStrategyClient();
        const promise = client.get(hierarchyId);
        promise.onSuccess((data) => {
            if (callBack) {
                callBack(data);
            }
        });

        promise.onError((err) => { });
    }

    public static getDrawdownPriceLock(
        hierarchyId: string,
        callBack?: (val: DrawdownPriceLockModel) => void
    ) {
        const client = new DrawdownPriceLockClient();
        const promise = client.get(hierarchyId);
        promise.onSuccess((data) => {
            if (callBack) {
                callBack(data);
            }
        });

        promise.onError((err) => { });
    }

    public static updateDrawdownPriceLock(
        hierarchyId: string,
        usePriceLock: boolean,
        callBack?: (val) => void
    ) {
        const client = new DrawdownPriceLockClient();
        const promise = client.put(hierarchyId, usePriceLock);
        promise.onSuccess((data) => {
            if (callBack) {
                callBack(data);
            }
        });

        promise.onError((err) => { });
    }

    public static updateAccountDisinvestmentStrategy(obj: AccountDisinvestmentStrategy, callBack?: (val) => void) {
        const client = new AccountDisinvestmentStrategyClient();
        const promise = client.put(obj);
        promise.onSuccess((data) => {
            if (callBack) {
                callBack(data);
            }
        });

        promise.onError((err) => { });
    }
}
